import { useAuth } from '@workos-inc/authkit-react';

export function ImpersonationBanner() {
  const { impersonator, user } = useAuth();
  if (!impersonator) return null;

  const targetLabel = user?.email ?? user?.id ?? 'user';

  return (
    <>
      <div
        aria-hidden="true"
        className="fixed inset-0 border-4 border-yellow-400 pointer-events-none z-40"
      />
      <div
        role="status"
        aria-live="polite"
        className="fixed bottom-0 inset-x-0 z-50 bg-yellow-400 text-black px-4 py-2 shadow-lg"
      >
        <span className="text-sm font-medium">
          You ({impersonator.email}) are impersonating <strong>{targetLabel}</strong>
          {impersonator.reason ? ` — ${impersonator.reason}` : ''}
        </span>
      </div>
    </>
  );
}
